// fonts/heading.ts
import {
  Albert_Sans as AlbertSans,
  Alegreya_Sans as AlegreyaSans,
  JetBrains_Mono as FontMono,
  Inter as FontSans,
  Manrope,
  Merriweather,
  Outfit,
  Plus_Jakarta_Sans,
  Space_Grotesk as SpaceGrotesk,
  EB_Garamond as EBGaramond,
} from 'next/font/google'
import { GeistMono } from 'geist/font/mono'
import { GeistSans } from 'geist/font/sans'

import { cn } from '@/lib/utils'

export const fontSans = FontSans({
  subsets: ['latin'],
  variable: '--font-sans',
  preload: false,
})

export const fontMono = FontMono({
  subsets: ['latin'],
  variable: '--font-mono',
  preload: false,
})

export const fontAlbertSans = AlbertSans({
  subsets: ['latin'],
  variable: '--font-albert-sans',
  display: 'swap',
  preload: false,
})

export const fontManrope = Manrope({
  subsets: ['latin'],
  variable: '--font-manrope',
  display: 'swap',
  preload: false,
})

export const fontOutfit = Outfit({
  subsets: ['latin'],
  variable: '--font-outfit-src',
  display: 'swap',
  preload: false,
})

export const fontAlegreyaSans = AlegreyaSans({
  subsets: ['latin'],
  variable: '--font-alegreya-sans',
  display: 'swap',
  weight: ['400', '500', '700'],
  preload: false,
})

export const fontMerriweather = Merriweather({
  subsets: ['latin'],
  variable: '--font-merriweather',
  display: 'swap',
  weight: ['300', '400', '700'],
  preload: false,
})

export const fontEBGaramond = EBGaramond({
  subsets: ['latin'],
  variable: '--font-eb-garamond',
  display: 'swap',
  weight: ['400', '500', '600', '700'],
  preload: false,
})

export { GeistMono, GeistSans }

export const heading = Plus_Jakarta_Sans({
  subsets: ['latin', 'latin-ext'],
  variable: '--font-plus-jakarta-sans',
  display: 'swap',
  preload: false,
})

export const fontSpaceGrotesk = SpaceGrotesk({
  subsets: ['latin', 'latin-ext'],
  variable: '--font-space-grotesk',
  display: 'swap',
  weight: ['400', '500', '600', '700'],
  preload: false,
})

// Note: Manrope is used for legal documents (already exported above)
// It provides excellent readability for long-form legal content

/** CSS variable classes for every `next/font` face used by `src/app/layout.tsx`. */
export const fontVariables = cn(
  GeistSans.variable,
  GeistMono.variable,
  fontAlbertSans.variable,
  fontManrope.variable,
  fontAlegreyaSans.variable,
  fontMerriweather.variable,
  heading.variable,
  fontOutfit.variable,
  fontSpaceGrotesk.variable,
  fontEBGaramond.variable,
)
